<template>
  <CommonCard>
    <div style="padding: 5%;">
      <v-container>
        <v-row class="mb-10" dense>
          <v-col cols="12">
            <span class="titulo-header">Clientes</span>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row align="center">
          <v-col cols="12" md="6" lg="8">
            <div class="d-flex align-center pb-0"></div>
          </v-col>
          <v-col cols="12" md="12" lg="12">
            <v-row dense>
              <v-col cols='12' style="text-align: end;">
                <v-btn
                  color="#00a7e4"
                  dark
                  
                  @click="$router.push('/leads/buscar')"
                  style="border-radius: 15px;"
                >
                  <v-icon small class="mr-1">mdi-magnify</v-icon>
                  <span>Buscar cliente</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-container class="pt-5">
        <v-row>
          <v-col
            cols="12"
            md="6"
            v-if="rol != 'AGENTCC' && rol != 'AGENTCCSPONSORS'"
          >
            <LeadsMarcacion :bus="bus" />
          </v-col>
          <v-col
            cols="12"
            :md="rol != 'AGENTCC' && rol != 'AGENTCCSPONSORS' ? '6' : '12'"
          >
            <LeadsAgenda />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </CommonCard>
</template>

<script>
import logoSegurify from "@/assets/logo_segurify.png";
import LeadsMarcacion from "@/components/leads/LeadsMarcacion";
import LeadsAgenda from "@/components/leads/LeadsAgenda";
import { loadScript } from "vue-plugin-load-script";
import { mainAxios } from "@/mainAxios";
import moment from "moment";
import LogoSegurify from "@/assets/logo_segurify.png";
import LogoBradescard from "@/assets/logo-inter-horizontal.png";
import Vue from "vue";
import CommonCard from "@/components/commonComponents/CommonCard.vue";

export default {
  components: {
    LeadsMarcacion,
    LeadsAgenda,
    CommonCard,
  },

  data() {
    return {
      logoSegurify,
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      showCreacion: false,
      bus: new Vue(),
      intervalo: null,
      data: [],
      isChecking: false,
      logo_1: LogoSegurify,
      width_log1: 80,
      height_log1: 80,

      logo_2: LogoBradescard,
      width_log2: 80,
      height_log2: 250,
    };
  },
  mounted() {
    loadScript(
      "https://aligev55.zw-callitonce.alestra.net.mx/agentdesktop/libs/servicepattern-sdk-v1.js"
    )
      .then(() => {
        window.bpspat.api.init("https://aligev55.zw-callitonce.alestra.net.mx");
      })
      .catch(() => {
        console.error(
          "Fallo al carga el sdk, Refresque la pagina para realizar la llamada"
        );
        location.reload();
      });
    setTimeout(() => this.checkStatus(), 30000).then(
      (this.intervalo = window.setInterval(() => {
        this.checkStatus();
      }, 10000))
    );
  },
  beforeDestroy() {
    clearInterval(this.intervalo);
  },

  computed: {
    widthLogoSeg() {
      if (this.$vuetify.breakpoint.smAndDown) return "50";
      if (this.$vuetify.breakpoint.mdAndDown) return "50";
      return "80";
    },

    puedeCrear() {
      const rolesValidos = [
        "ADMIN",
        "ADMINCC",
        "MANAGERCC",
        "MANAGER",
        "ADMINAGENT",
        "DIRECTO",
        "OPERACIONES",
        "OPERADOR",
      ];
      return !!rolesValidos.find((e) => e == this.rol);
    },
  },

  methods: {
    leadCreado() {
      this.showCreacion = false;
      this.bus.$emit("reload");
    },
    checkStatus() {
      //Comentado momentaneamente para no pasar marcacion automatica a productivo
      if (
        (this.rol == "AGENTCC" || this.rol == "AGENTCCSPONSORS") &&
        !this.isChecking
      ) {
        window.bpspat.api.getState(this.statusChecked);
      }
    },
    getLeadsMarcacion() {
      this.data = [];
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios.get("/v1/origenLead/llamadaMasiva", config).then((response) => {
        response.data.map((element) => {
          let jsonFormat = element.request_json
            ? JSON.parse(element.request_json)
            : {};
          this.data.push({
            fecha_lead:
              element.fecha_lead ?? ""
                ? moment.utc(element.fecha_lead).format("DD/MM/YYYY")
                : "No Disponible",
            ramo: element.ramo ? element.ramo : "",
            producto: element.producto ? element.producto : "",
            status: element.status ? element.status : "",
            lead:
              jsonFormat.nombre +
              " " +
              jsonFormat.apellidopaterno +
              " " +
              jsonFormat.apellidomaterno,
            uuid_lead_segurify: element.uuid_lead_segurify
              ? element.uuid_lead_segurify
              : "",
            uuid: element.uuid ? element.uuid : "",
            telefono: element.telefono ? element.telefono : "",
            servicio_embebido: element.servicio_embebido
              ? element.servicio_embebido
              : null,
            id: element.id ? element.id : "",
            embedded: true,
            marcacion_automatica: true,
            error: element.error ? element.error : null,
          });
        });
        this.completarllamadaAuto();
      });
    },
    completarllamadaAuto() {
      if (this.data.length > 0) {
        var currentItem = {};
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].operador_id == null) {
            currentItem = this.data[i];
            break;
          }
        }
        if (currentItem.error == null) {
          this.$toast("Consultando disponibilidad del lead", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          const duracionAleatoria = Math.floor(Math.random() * 4000) + 1000;
          setTimeout(() => {
            this.checarDisponibilidadLead(currentItem);
          }, duracionAleatoria);
        }
      }
    },
    statusChecked(state) {
      if (state.data.status == "ready") {
        this.getLeadsMarcacion();
      }
    },
    changeRoute(item) {
      this.$router.push('/segurify/leads-segurify/lead/'+item.uuid_lead_segurify);
    },
    actualizarLead(item) {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      const enviar = {
        operador_id: "01",
      };
      mainAxios
        .post("/v1/origen/actualizar/" + item.uuid, enviar, config)
        .then((response) => {
          console.log("Se actualizo el lead ", response);
        });
    },
    checarDisponibilidadLead(item) {
      this.isChecking = true;
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios.get(`/v1/origen/uuid/${item.uuid}`, config).then((response) => {
        if (response.data.operador_id != null) {
          this.$toast.warning("Lead en marcacion", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          this.isChecking = false;
        } else {
          this.actualizarLead(item);
          this.changeRoute(item);
        }
      });
    },
  },
};
</script>
